//#region IMPORTS
import {Type} from '@angular/core';

import {IconAlertBoxOutlineComponent} from './icon-alert-box-outline/icon-alert-box-outline.component';
import {IconAlertBoxComponent} from './icon-alert-box/icon-alert-box.component';
import {
  IconAlignHorizontalCenterComponent,
} from './icon-align-horizontal-center/icon-align-horizontal-center.component';
import {IconAlignVerticalCenterComponent} from './icon-align-vertical-center/icon-align-vertical-center.component';
import {IconAlphaComponent} from './icon-alpha/icon-alpha.component';
import {IconArchiveMarkerOutlineComponent} from './icon-archive-marker-outline/icon-archive-marker-outline.component';
import {IconArchiveMarkerComponent} from './icon-archive-marker/icon-archive-marker.component';
import {IconArrowDownComponent} from './icon-arrow-down/icon-arrow-down.component';
import {IconArrowLeftComponent} from './icon-arrow-left/icon-arrow-left.component';
import {IconArrowRightComponent} from './icon-arrow-right/icon-arrow-right.component';
import {IconArrowUpComponent} from './icon-arrow-up/icon-arrow-up.component';
import {IconBackspaceOutlineComponent} from './icon-backspace-outline/icon-backspace-outline.component';
import {IconBandageComponent} from './icon-bandage/icon-bandage.component';
import {IconBarcodeOffComponent} from './icon-barcode-off/icon-barcode-off.component';
import {IconBarcodeScanComponent} from './icon-barcode-scan/icon-barcode-scan.component';
import {IconBarcodeComponent} from './icon-barcode/icon-barcode.component';
import {IconBellOffOutlineComponent} from './icon-bell-off-outline/icon-bell-off-outline.component';
import {IconBellOutlineComponent} from './icon-bell-outline/icon-bell-outline.component';
import {IconBetaComponent} from './icon-beta/icon-beta.component';
import {IconBiohazardComponent} from './icon-biohazard/icon-biohazard.component';
import {IconBugOutlineComponent} from './icon-bug-outline/icon-bug-outline.component';
import {IconBugComponent} from './icon-bug/icon-bug.component';
import {IconCBoxOutlineComponent} from './icon-c-box-outline/icon-c-box-outline.component';
import {IconCalculatorComponent} from './icon-calculator/icon-calculator.component';
import {IconCalendarClearComponent} from './icon-calendar-clear/icon-calendar-clear.component';
import {
  IconCalendarMultiselectOutlineComponent,
} from './icon-calendar-multiselect-outline/icon-calendar-multiselect-outline.component';
import {IconCalendarMultiselectComponent} from './icon-calendar-multiselect/icon-calendar-multiselect.component';
import {IconCalendarComponent} from './icon-calendar/icon-calendar.component';
import {
  IconCameraLockOpenOutlineComponent,
} from './icon-camera-lock-open-outline/icon-camera-lock-open-outline.component';
import {IconCameraLockOpenComponent} from './icon-camera-lock-open/icon-camera-lock-open.component';
import {IconCameraLockOutlineComponent} from './icon-camera-lock-outline/icon-camera-lock-outline.component';
import {IconCameraLockComponent} from './icon-camera-lock/icon-camera-lock.component';
import {IconCameraOffOutlineComponent} from './icon-camera-off-outline/icon-camera-off-outline.component';
import {IconCameraOffComponent} from './icon-camera-off/icon-camera-off.component';
import {IconCameraOutlineComponent} from './icon-camera-outline/icon-camera-outline.component';
import {IconCameraComponent} from './icon-camera/icon-camera.component';
import {IconCancelComponent} from './icon-cancel/icon-cancel.component';
import {IconCartFilledComponent} from './icon-cart-filled/icon-cart-filled.component';
import {IconCartOutlineComponent} from './icon-cart-outline/icon-cart-outline.component';
import {IconCartVariantComponent} from './icon-cart-variant/icon-cart-variant.component';
import {IconCartComponent} from './icon-cart/icon-cart.component';
import {IconCashCheckComponent} from './icon-cash-check/icon-cash-check.component';
import {IconCashClockComponent} from './icon-cash-clock/icon-cash-clock.component';
import {IconCashEditComponent} from './icon-cash-edit/icon-cash-edit.component';
import {IconCashFastComponent} from './icon-cash-fast/icon-cash-fast.component';
import {IconCashLockOpenComponent} from './icon-cash-lock-open/icon-cash-lock-open.component';
import {IconCashLockComponent} from './icon-cash-lock/icon-cash-lock.component';
import {IconCashMarkerComponent} from './icon-cash-marker/icon-cash-marker.component';
import {IconCashMinusComponent} from './icon-cash-minus/icon-cash-minus.component';
import {IconCashMultipleComponent} from './icon-cash-multiple/icon-cash-multiple.component';
import {IconCashOffComponent} from './icon-cash-off/icon-cash-off.component';
import {IconCashPlusComponent} from './icon-cash-plus/icon-cash-plus.component';
import {IconCashRefundComponent} from './icon-cash-refund/icon-cash-refund.component';
import {IconCashRegisterComponent} from './icon-cash-register/icon-cash-register.component';
import {IconCashRemoveComponent} from './icon-cash-remove/icon-cash-remove.component';
import {IconCashSyncComponent} from './icon-cash-sybc/icon-cash-sync.component';
import {IconCashComponent} from './icon-cash/icon-cash.component';
import {IconChatOutlineComponent} from './icon-chat-outline/icon-chat-outline.component';
import {IconChatComponent} from './icon-chat/icon-chat.component';
import {IconCheckAllComponent} from './icon-check-all/icon-check-all.component';
import {IconCheckBoldComponent} from './icon-check-bold/icon-check-bold.component';
import {IconCheckCircleOutlineComponent} from './icon-check-circle-outline/icon-check-circle-outline.component';
import {IconCheckCircleComponent} from './icon-check-circle/icon-check-circle.component';
import {
  IconCheckUnderlineCircleOutlineComponent,
} from './icon-check-underline-circle-outline/icon-check-underline-circle-outline.component';
import {IconCheckUnderlineCircleComponent} from './icon-check-underline-circle/icon-check-underline-circle.component';
import {IconCheckUnderlineComponent} from './icon-check-underline/icon-check-underline.component';
import {IconCheckOutlineComponent} from './icon-check-outline/icon-check-outline.component';
import {IconChemicalWeaponComponent} from './icon-chemical-weapon/icon-chemical-weapon.component';
import {IconChevronDownComponent} from './icon-chevron-down/icon-chevron-down.component';
import {
  IconChevronLeftCircleOutlineComponent,
} from './icon-chevron-left-circle-outline/icon-chevron-left-circle-outline.component';
import {IconChevronLeftComponent} from './icon-chevron-left/icon-chevron-left.component';
import {
  IconChevronRightCircleOutlineComponent,
} from './icon-chevron-right-circle-outline/icon-chevron-right-circle-outline.component';
import {IconChevronRightComponent} from './icon-chevron-right/icon-chevron-right.component';
import {IconChevronUpComponent} from './icon-chevron-up/icon-chevron-up.component';
import {IconClipboardComponent} from './icon-clipboard/icon-clipboard.component';
import {
  IconClipboardCheckOutlineComponent,
} from './icon-clipboard-check-outline/icon-clipboard-check-outline.component';
import {IconClockComponent} from './icon-clock/icon-clock.component';
import {IconCloseBoxOutlineComponent} from './icon-close-box-outline/icon-close-box-outline.component';
import {IconCloseBoxComponent} from './icon-close-box/icon-close-box.component';
import {IconCloseCircleOutlineComponent} from './icon-close-circle-outline/icon-close-circle-outline.component';
import {IconCloseCircleComponent} from './icon-close-circle/icon-close-circle.component';
import {IconCloseOctagonOutlineComponent} from './icon-close-octagon-outline/icon-close-octagon-outline.component';
import {IconCloseOctagonComponent} from './icon-close-octagon/icon-close-octagon.component';
import {IconCloseOutlineComponent} from './icon-close-outline/icon-close-outline.component';
import {IconCloseThickComponent} from './icon-close-thick/icon-close-thick.component';
import {IconCloseComponent} from './icon-close/icon-close.component';
import {IconCogBoxComponent} from './icon-cog-box/icon-cog-box.component';
import {IconCogOutlineComponent} from './icon-cog-outline/icon-cog-outline.component';
import {IconCogComponent} from './icon-cog/icon-cog.component';
import {IconContentCopyComponent} from './icon-content-copy/icon-content-copy.component';
import {IconContentSaveOutlineComponent} from './icon-content-save-outline/icon-content-save-outline.component';
import {IconContentSaveComponent} from './icon-content-save/icon-content-save.component';
import {IconCreateComponent} from './icon-create/icon-create.component';
import {IconCustomSortUpDownComponent} from './icon-custom-sort-up-down/icon-custom-sort-up-down.component';
import {IconDeleteClockOutlineComponent} from './icon-delete-clock-outline/icon-delete-clock-outline.component';
import {IconDeleteClockComponent} from './icon-delete-clock/icon-delete-clock.component';
import {IconDeleteEmptyOutlineComponent} from './icon-delete-empty-outline/icon-delete-empty-outline.component';
import {IconDeleteEmptyComponent} from './icon-delete-empty/icon-delete-empty.component';
import {IconDeleteForeverOutlineComponent} from './icon-delete-forever-outline/icon-delete-forever-outline.component';
import {IconDeleteForeverComponent} from './icon-delete-forever/icon-delete-forever.component';
import {IconDeleteOutlineComponent} from './icon-delete-outline/icon-delete-outline.component';
import {IconDeleteSweepOutlineComponent} from './icon-delete-sweep-outline/icon-delete-sweep-outline.component';
import {IconDeleteSweepComponent} from './icon-delete-sweep/icon-delete-sweep.component';
import {IconDeleteComponent} from './icon-delete/icon-delete.component';
import {IconDeltaComponent} from './icon-delta/icon-delta.component';
import {IconDevToComponent} from './icon-dev-to/icon-dev-to.component';
import {IconDotsVerticalComponent} from './icon-dots-vertical/icon-dots-vertical.component';
import {IconDownloadOutlineComponent} from './icon-download-outline/icon-download-outline.component';
import {IconDownloadComponent} from './icon-download/icon-download.component';
import {IconEmailAlertOutlineComponent} from './icon-email-alert-outline/icon-email-alert-outline.component';
import {IconEmailCheckOutlineComponent} from './icon-email-check-outline/icon-email-check-outline.component';
import {IconEmailFastOutlineComponent} from './icon-email-fast-outline/icon-email-fast-outline.component';
import {IconEmailSyncOutlineComponent} from './icon-email-sync-outline/icon-email-sync-outline.component';
import {IconEmailVariantComponent} from './icon-email-variant/icon-email-variant.component';
import {IconEpsilonComponent} from './icon-epsilon/icon-epsilon.component';
import {IconEyeOffOutlineComponent} from './icon-eye-off-outline/icon-eye-off-outline.component';
import {IconEyeOutlineComponent} from './icon-eye-outline/icon-eye-outline.component';
import {IconFileTrayStackedComponent} from './icon-file-tray-stacked/icon-file-tray-stacked.component';
import {IconFilterCogOutlineComponent} from './icon-filter-cog-outline/icon-filter-cog-outline.component';
import {IconFilterVariantMinusComponent} from './icon-filter-variant-minus/icon-filter-variant-minus.component';
import {IconFilterVariantPlusComponent} from './icon-filter-variant-plus/icon-filter-variant-plus.component';
import {IconFilterVariantRemoveComponent} from './icon-filter-variant-remove/icon-filter-variant-remove.component';
import {IconFilterVariantComponent} from './icon-filter-variant/icon-filter-variant.component';
import {IconFlashlightOffComponent} from './icon-flashlight-off/icon-flashlight-off.component';
import {IconFlashlightComponent} from './icon-flashlight/icon-flashlight.component';
import {IconFolderComponent} from './icon-folder/icon-folder.component';
import {IconFolderAlertComponent} from './icon-folder-alert/icon-folder-alert.component';
import {IconFormatAlignCenterComponent} from './icon-format-align-center/icon-format-align-center.component';
import {IconFormatAlignLeftComponent} from './icon-format-align-left/icon-format-align-left.component';
import {IconFormatAlignRightComponent} from './icon-format-align-right/icon-format-align-right.component';
import {IconFormatBoldComponent} from './icon-format-bold/icon-format-bold.component';
import {IconFormatItalicComponent} from './icon-format-italic/icon-format-italic.component';
import {IconFullScreenExitComponent} from './icon-full-screen-exit/icon-full-screen-exit.component';
import {IconFullScreenComponent} from './icon-full-screen/icon-full-screen.component';
import {IconGammaComponent} from './icon-gamma/icon-gamma.component';
import {IconGoogleDinosaurComponent} from './icon-google-dinosaur/icon-google-dinosaur.component';
import {IconHelpCircleOutlineComponent} from './icon-help-circle-outline/icon-help-circle-outline.component';
import {IconHomeComponent} from './icon-home/icon-home.component';
import {
  IconInfoSlabCircleOutlineComponent,
} from './icon-info-slab-circle-outline/icon-info-slab-circle-outline.component';
import {IconKeyComponent} from './icon-key/icon-key.component';
import {IconLinkVariantComponent} from './icon-link-variant/icon-link-variant.component';
import {IconLockClosedOutlineComponent} from './icon-lock-closed-outline/icon-lock-closed-outline.component';
import {IconLockOpenOutlineComponent} from './icon-lock-open-outline/icon-lock-open-outline.component';
import {IconLogInComponent} from './icon-log-in/icon-log-in.component';
import {IconLogoIQComponent} from './icon-logo-iq/icon-logo-iq.component';
import {IconMagnifyMinusOutlineComponent} from './icon-magnify-minus-outline/icon-magnify-minus-outline.component';
import {IconMagnifyPlusOutlineComponent} from './icon-magnify-plus-outline/icon-magnify-plus-outline.component';
import {IconMagnifyRemoveOutlineComponent} from './icon-magnify-remove-outline/icon-magnify-remove-outline.component';
import {IconMagnifyComponent} from './icon-magnify/icon-magnify.component';
import {IconMailComponent} from './icon-mail/icon-mail.component';
import {IconMenuComponent} from './icon-menu/icon-menu.component';
import {IconMessageAlertOutlineComponent} from './icon-message-alert-outline/icon-message-alert-outline.component';
import {IconMessageAlertComponent} from './icon-message-alert/icon-message-alert.component';
import {IconNewBoxComponent} from './icon-new-box/icon-new-box.component';
import {IconNotEqualVariantComponent} from './icon-not-equal-variant/icon-not-equal-variant.component';
import {IconOpenInNewComponent} from './icon-open-in-new/icon-open-in-new.component';
import {IconPageFirstComponent} from './icon-page-first/icon-page-first.component';
import {IconPageLastComponent} from './icon-page-last/icon-page-last.component';
import {IconPauseBoxOutlineComponent} from './icon-pause-box-outline/icon-pause-box-outline.component';
import {IconPauseBoxComponent} from './icon-pause-box/icon-pause-box.component';
import {IconPauseComponent} from './icon-pause/icon-pause.component';
import {IconPdfBoxComponent} from './icon-pdf-box/icon-pdf-box.component';
import {IconPencilOffComponent} from './icon-pencil-off/icon-pencil-off.component';
import {IconPencilComponent} from './icon-pencil/icon-pencil.component';
import {IconPersonMinusOutlineComponent} from './icon-person-minus-outline/icon-person-minus-outline.component';
import {
  IconPersonMultipleMinusOutlineComponent,
} from './icon-person-multiple-minus-outline/icon-person-multiple-minus-outline.component';
import {
  IconPersonMultiplePlusOutlineComponent,
} from './icon-person-multiple-plus-outline/icon-person-multiple-plus-outline.component';
import {IconPersonOffOutlineComponent} from './icon-person-off-outline/icon-person-off-outline.component';
import {IconPersonPlusOutlineComponent} from './icon-person-plus-outline/icon-person-plus-outline.component';
import {IconPersonComponent} from './icon-person/icon-person.component';
import {IconPieChartComponent} from './icon-pie-chart/icon-pie-chart.component';
import {IconPintComponent} from './icon-pint/icon-pint.component';
import {IconPlanetComponent} from './icon-planet/icon-planet.component';
import {IconPlayBoxOutlineComponent} from './icon-play-box-outline/icon-play-box-outline.component';
import {IconPlayBoxComponent} from './icon-play-box/icon-play-box.component';
import {IconPlayComponent} from './icon-play/icon-play.component';
import {IconPlaylistPlusComponent} from './icon-playlist-plus/icon-playlist-plus.component';
import {IconPlusComponent} from './icon-plus/icon-plus.component';
import {IconPriceTagsComponent} from './icon-price-tags/icon-price-tags.component';
import {IconPrinterOutlineComponent} from './icon-printer-outline/icon-printer-outline.component';
import {IconProgressPencilComponent} from './icon-progress-pencil/icon-progress-pencil.component';
import {IconRadioboxBlankComponent} from './icon-radiobox-blank/icon-radiobox-blank.component';
import {IconRadioboxMarkedComponent} from './icon-radiobox-marked/icon-radiobox-marked.component';
import {IconReceiptOutlineComponent} from './icon-receipt-outline/icon-receipt-outline.component';
import {
  IconReceiptTextCheckOutlineComponent,
} from './icon-receipt-text-check-outline/icon-receipt-text-check-outline.component';
import {
  IconReceiptTextEditOutlineComponent,
} from './icon-receipt-text-edit-outline/icon-receipt-text-edit-outline.component';
import {IconReceiptTextOutlineComponent} from './icon-receipt-text-outline/icon-receipt-text-outline.component';
import {
  IconReceiptTextRemoveOutlineComponent,
} from './icon-receipt-text-remove-outline/icon-receipt-text-remove-outline.component';
import {
  IconReceiptTextSendOutlineComponent,
} from './icon-receipt-text-send-outline/icon-receipt-text-send-outline.component';
import {IconRotateOrbitComponent} from './icon-rotate-orbit/icon-rotate-orbit.component';
import {IconSecurityComponent} from './icon-security/icon-security.component';
import {IconSettingsComponent} from './icon-settings/icon-settings.component';
import {IconShieldAirplaneOutlineComponent} from './icon-shield-airplane-outline/icon-shield-airplane-outline';
import {IconShieldAirplaneComponent} from './icon-shield-airplane/icon-shield-airplane';
import {IconShoppingOutlineComponent} from './icon-shopping-outline/icon-shopping-outline.component';
import {IconShoppingComponent} from './icon-shopping/icon-shopping.component';
import {IconSkullScanOutlineComponent} from './icon-skull-scan-outline/icon-skull-scan-outline.component';
import {IconSkullScanComponent} from './icon-skull-scan/icon-skull-scan.component';
import {IconSortComponent} from './icon-sort/icon-sort.component';
import {IconStoreEditOutlineComponent} from './icon-store-edit-outline/icon-store-edit-outline.component';
import {IconStoreEditComponent} from './icon-store-edit/icon-store-edit.component';
import {IconStoreMultipleComponent} from './icon-store-multiple/icon-store-multiple.component';
import {IconStoreOutlineComponent} from './icon-store-outline/icon-store-outline.component';
import {IconStoreRemoveComponent} from './icon-store-remove/icon-store-remove.component';
import {IconStoreComponent} from './icon-store/icon-store.component';
import {IconSyncComponent} from './icon-sync/icon-sync.component';
import {IconTableCogComponent} from './icon-table-cog/icon-table-cog.component';
import {IconTagMultipleOutlineComponent} from './icon-tag-multiple-outline/icon-tag-multiple-outline.component';
import {IconTagMultipleComponent} from './icon-tag-multiple/icon-tag-multiple.component';
import {IconTerminalComponent} from './icon-terminal/icon-terminal.component';
import {IconTimerSandComponent} from './icon-timer-sand/icon-timer-sand.component';
import {IconTodayComponent} from './icon-today/icon-today.component';
import {IconTuneVariantComponent} from './icon-tune-variant/icon-tune-variant.component';
import {IconTuneVerticalVariantComponent} from './icon-tune-vertical-variant/icon-tune-vertical-variant.component';
import {IconTuneVerticalComponent} from './icon-tune-vertical/icon-tune-vertical.component';
import {IconTuneComponent} from './icon-tune/icon-tune.component';
import {LogoFullComponent} from './logo-full/logo-full.component';
import {LogoGComponent} from './logo-g/logo-g.component';
import {StylingSvgLoginComponent} from './styling-svg-login/styling-svg-login.component';
import {StylingSvgComponent} from './styling-svg/styling-svg.component';
import {IconAccountComponent} from './icon-account/icon-account.component';
import {IconAccountRemoveOutlineComponent} from './icon-account-remove-outline/icon-account-remove-outline.component';
import {IconAccountPlusOutlineComponent} from './icon-account-plus-outline/icon-account-plus-outline.component';
import {IconAccountCogComponent} from './icon-account-cog/icon-account-cog.component';
import {IconAccountCogOutlineComponent} from './icon-account-cog-outline/icon-account-cog-outline.component';
import {IconAccountEditComponent} from './icon-account-edit/icon-account-edit.component';
import {IconAccountEditOutlineComponent} from './icon-account-edit-outline/icon-account-edit-outline.component';
import {IconAccountMinusComponent} from './icon-account-minus/icon-account-minus.component';
import {IconAccountMinusOutlineComponent} from './icon-account-minus-outline/icon-account-minus-outline.component';
import {IconAccountOutlineComponent} from './icon-account-outline/icon-account-outline.component';
import {IconAccountPlusComponent} from './icon-account-plus/icon-account-plus.component';
import {IconAccountRemoveComponent} from './icon-account-remove/icon-account-remove.component';
import {IconUndoComponent} from './icon-undo-component/icon-undo-component';
import {IconUndoVariantComponent} from './icon-undo-variant-component/icon-undo-variant-component';
import {IconAlertRhombusComponent} from './icon-alert-rhombus-component/icon-alert-rhombus-component';
import {
  IconAlertRhombusOutlineComponent,
} from './icon-alert-rhombus-outline-component/icon-alert-rhombus-outline-component';
import {IconBookSettingsComponent} from './icon-book-settings.component/icon-book-settings.component';
import {IconBookSettingsOutlineComponent} from './icon-book-settings-outline/icon-book-settings-outline.component';
import {IconEmailPlusComponent} from './icon-email-plus.component/icon-email-plus.component';
import {IconEmailPlusOutlineComponent} from './icon-email-plus-outline.component/icon-email-plus-outline.component';
import {
  IconEmailRemoveOutlineComponent,
} from './icon-email-remove-outline.component/icon-email-remove-outline.component';
import {IconEmailRemoveComponent} from './icon-email-remove.component/icon-email-remove.component';
import {IconFlagOutlineComponent} from './icon-flag/icon-flag';
import {IconProgressClockComponent} from './icon-progress-clock/icon-progress-clock';
import {IconApplicationCogComponent} from './icon-application-cog/icon-application-cog.component';
import {
  IconApplicationCogOutlineComponent,
} from './icon-application-cog-outline/icon-application-cog-outline.component';
import {IconFileCogComponent} from './icon-file-cog/icon-file-cog.component';
import {IconFileCogOutlineComponent} from './icon-file-cog-outline/icon-file-cog-outline.component';
import {IconSwapVerticalComponent} from './icon-swap-vertical/icon-swap-vertical.component';
//#endregion

//#region ICON ENUM (alphabetical)
export enum IconKey {
  account = 'account',
  accountCog = 'accountCog',
  accountCogOutline = 'accountCogOutline',
  accountEdit = 'accountEdit',
  accountEditOutline = 'accountEditOutline',
  accountMinus = 'accountMinus',
  accountMinusOutline = 'accountMinusOutline',
  accountOutline = 'accountOutline',
  accountPlus = 'accountPlus',
  accountPlusOutline = 'accountPlusOutline',
  accountRemove = 'accountRemove',
  accountRemoveOutline = 'accountRemoveOutline',
  alertBox = 'alertBox',
  alertBoxOutline = 'alertBoxOutline',
  alertRhombus = 'alertRhombus',
  alertRhombusOutline = 'alertRhombusOutline',
  alignHorizontalCenter = 'alignHorizontalCenter',
  alignVerticalCenter = 'alignVerticalCenter',
  alpha = 'alpha',
  applicationCog = 'applicationCog',
  applicationCogOutline = 'applicationCogOutline',
  archiveMarker = 'archiveMarker',
  archiveMarkerOutline = 'archiveMarkerOutline',
  arrowDown = 'arrowDown',
  arrowLeft = 'arrowLeft',
  arrowRight = 'arrowRight',
  arrowUp = 'arrowUp',
  backSpaceOutline = 'backSpaceOutline',
  bandage = 'bandage',
  barcode = 'barcode',
  barcodeOff = 'barcodeOff',
  barcodeScan = 'barcodeScan',
  bellOffOutline = 'bellOffOutline',
  bellOutline = 'bellOutline',
  beta = 'beta',
  biohazard = 'biohazard',
  bookSettings = 'bookSettings',
  bookSettingsOutline = 'bookSettingsOutline',
  bug = 'bug',
  bugOutline = 'bugOutline',
  cBoxOutline = 'cBoxOutline',
  calculator = 'calculator',
  calendar = 'calendar',
  calendarClear = 'calendarClear',
  calendarMultiSelect = 'calendarMultiSelect',
  calendarMultiSelectOutline = 'calendarMultiSelectOutline',
  camera = 'camera',
  cameraLock = 'cameraLock',
  cameraLockOpen = 'cameraLockOpen',
  cameraLockOpenOutline = 'cameraLockOpenOutline',
  cameraLockOutline = 'cameraLockOutline',
  cameraOff = 'cameraOff',
  cameraOffOutline = 'cameraOffOutline',
  cameraOutline = 'cameraOutline',
  cancel = 'cancel',
  cart = 'cart',
  cartFilled = 'cartFilled',
  cartOutline = 'cartOutline',
  cartVariant = 'cartVariant',
  cash = 'cash',
  cashCheck = 'cashCheck',
  cashClock = 'cashClock',
  cashEdit = 'cashEdit',
  cashFast = 'cashFast',
  cashLock = 'cashLock',
  cashLockOpen = 'cashLockOpen',
  cashMarker = 'cashMarker',
  cashMinus = 'cashMinus',
  cashMultiple = 'cashMultiple',
  cashOff = 'cashOff',
  cashPlus = 'cashPlus',
  cashRefund = 'cashRefund',
  cashRegister = 'cashRegister',
  cashRemove = 'cashRemove',
  cashSync = 'cashSync',
  chat = 'chat',
  chatOutline = 'chatOutline',
  checkAll = 'checkAll',
  checkBold = 'checkBold',
  checkCircle = 'checkCircle',
  checkCircleOutline = 'checkCircleOutline',
  checkOutline = 'checkOutline',
  checkUnderline = 'checkUnderline',
  checkUnderlineCircle = 'checkUnderlineCircle',
  checkUnderlineCircleOutline = 'checkUnderlineCircleOutline',
  chemicalWeapon = 'chemicalWeapon',
  chevronDown = 'chevronDown',
  chevronLeft = 'chevronLeft',
  chevronLeftCircleOutline = 'chevronLeftCircleOutline',
  chevronRight = 'chevronRight',
  chevronRightCircleOutline = 'chevronRightCircleOutline',
  chevronUp = 'chevronUp',
  clipboard = 'clipboard',
  clipboardCheckOutline = 'clipboardCheckOutline',
  clock = 'clock',
  close = 'close',
  closeBox = 'closeBox',
  closeBoxOutline = 'closeBoxOutline',
  closeCircle = 'closeCircle',
  closeCircleOutline = 'closeCircleOutline',
  closeOctagon = 'closeOctagon',
  closeOctagonOutline = 'closeOctagonOutline',
  closeOutline = 'closeOutline',
  closeThick = 'closeThick',
  cog = 'cog',
  cogBox = 'cogBox',
  cogOutline = 'cogOutline',
  contentCopy = 'contentCopy',
  contentSave = 'contentSave',
  contentSaveOutline = 'contentSaveOutline',
  create = 'create',
  customSortUpDown = 'customSortUpDown',
  delta = 'delta',
  delete = 'delete',
  deleteClock = 'deleteClock',
  deleteClockOutline = 'deleteClockOutline',
  deleteEmpty = 'deleteEmpty',
  deleteEmptyOutline = 'deleteEmptyOutline',
  deleteForever = 'deleteForever',
  deleteForeverOutline = 'deleteForeverOutline',
  deleteOutline = 'deleteOutline',
  deleteSweep = 'deleteSweep',
  deleteSweepOutline = 'deleteSweepOutline',
  devTo = 'devTo',
  dotsVertical = 'dotsVertical',
  download = 'download',
  downloadOutline = 'downloadOutline',
  emailAlertOutline = 'emailAlertOutline',
  emailCheckOutline = 'emailCheckOutline',
  emailFastOutline = 'emailFastOutline',
  emailPlus = 'emailPlus',
  emailPlusOutline = 'emailPlusOutline',
  emailRemove = 'emailRemove',
  emailRemoveOutline = 'emailRemoveOutline',
  emailSyncOutline = 'emailSyncOutline',
  emailVariant = 'emailVariant',
  epsilon = 'epsilon',
  eyeOffOutline = 'eyeOffOutline',
  eyeOutline = 'eyeOutline',
  fileCog = 'fileCog',
  fileCogOutline = 'fileCogOutline',
  fileTrayStacked = 'fileTrayStacked',
  filterCogOutline = 'filterCogOutline',
  filterVariant = 'filterVariant',
  filterVariantMinus = 'filterVariantMinus',
  filterVariantPlus = 'filterVariantPlus',
  filterVariantRemove = 'filterVariantRemove',
  flagOutline = 'flagOutline',
  flashlight = 'flashlight',
  flashlightOff = 'flashlightOff',
  folder = 'folder',
  folderAlert = 'folderAlert',
  formatAlignCenter = 'formatAlignCenter',
  formatAlignLeft = 'formatAlignLeft',
  formatAlignRight = 'formatAlignRight',
  formatBold = 'formatBold',
  formatItalic = 'formatItalic',
  fullScreen = 'fullScreen',
  fullScreenExit = 'fullScreenExit',
  gamma = 'gamma',
  googleDinosaur = 'googleDinosaur',
  helpCircleOutline = 'helpCircleOutline',
  home = 'home',
  infoSlabCircleOutline = 'infoSlabCircleOutline',
  key = 'key',
  linkVariant = 'linkVariant',
  lockClosedOutline = 'lockClosedOutline',
  lockOpenOutline = 'lockOpenOutline',
  logIn = 'logIn',
  logoFull = 'logoFull',
  logoG = 'logoG',
  logoIQ = 'logoIQ',
  magnify = 'magnify',
  magnifyMinus = 'magnifyMinus',
  magnifyPlus = 'magnifyPlus',
  magnifyRemove = 'magnifyRemove',
  mail = 'mail',
  menu = 'menu',
  messageAlert = 'messageAlert',
  messageAlertOutline = 'messageAlertOutline',
  newBox = 'newBox',
  notEqualVariant = 'notEqualVariant',
  openInNew = 'openInNew',
  pageFirst = 'pageFirst',
  pageLast = 'pageLast',
  pause = 'pause',
  pauseBox = 'pauseBox',
  pauseBoxOutline = 'pauseBoxOutline',
  pdfBox = 'pdfBox',
  pencil = 'pencil',
  pencilOff = 'pencilOff',
  person = 'person',
  personMinusOutline = 'personMinusOutline',
  personMultipleMinusOutline = 'personMultipleMinusOutline',
  personMultiplePlusOutline = 'personMultiplePlusOutline',
  personOffOutline = 'personOffOutline',
  personPlusOutline = 'personPlusOutline',
  pieChart = 'pieChart',
  pint = 'pint',
  planet = 'planet',
  play = 'play',
  playBox = 'playBox',
  playBoxOutline = 'playBoxOutline',
  playlistPlus = 'playlistPlus',
  plus = 'plus',
  priceTags = 'priceTags',
  printerOutline = 'printerOutline',
  progressClock = 'progressClock',
  progressPencil = 'progressPencil',
  radioBoxBlank = 'radioBoxBlank',
  radioBoxMarked = 'radioBoxMarked',
  receiptOutline = 'receiptOutline',
  receiptTextCheckOutline = 'receiptTextCheckOutline',
  receiptTextEditOutline = 'receiptTextEditOutline',
  receiptTextOutline = 'receiptTextOutline',
  receiptTextRemoveOutline = 'receiptTextRemoveOutline',
  receiptTextSendOutline = 'receiptTextSendOutline',
  rotateOrbit = 'rotateOrbit',
  security = 'security',
  settings = 'settings',
  shieldAirplane = 'shieldAirplane',
  shieldAirplaneOutline = 'shieldAirplaneOutline',
  shopping = 'shopping',
  shoppingOutline = 'shoppingOutline',
  skullScan = 'skullScan',
  skullScanOutline = 'skullScanOutline',
  sort = 'sort',
  store = 'store',
  storeMultiple = 'storeMultiple',
  storeEdit = 'storeEdit',
  storeEditOutline = 'storeEditOutline',
  storeOutline = 'storeOutline',
  storeRemove = 'storeRemove',
  stylingSvg = 'stylingSvg',
  stylingSvgLogin = 'stylingSvgLogin',
  swapVertical = 'swapVertical',
  sync = 'sync',
  tableCog = 'tableCog',
  tagMultiple = 'tagMultiple',
  tagMultipleOutline = 'tagMultipleOutline',
  terminal = 'terminal',
  timerSand = 'timerSand',
  today = 'today',
  tune = 'tune',
  tuneVariant = 'tuneVariant',
  tuneVertical = 'tuneVertical',
  tuneVerticalVariant = 'tuneVerticalVariant',
  undo = 'undo',
  undoVariant = 'undoVariant',
}

//#endregion

//#region SHARED ICONS ARRAY (alphabetical)
export const SHARED_ICONS: readonly Type<unknown>[] = [
  IconAccountComponent,
  IconAccountCogComponent,
  IconAccountCogOutlineComponent,
  IconAccountEditComponent,
  IconAccountEditOutlineComponent,
  IconAccountMinusComponent,
  IconAccountMinusOutlineComponent,
  IconAccountOutlineComponent,
  IconAccountPlusComponent,
  IconAccountPlusOutlineComponent,
  IconAccountRemoveComponent,
  IconAccountRemoveOutlineComponent,
  IconAlertBoxComponent,
  IconAlertBoxOutlineComponent,
  IconAlertRhombusComponent,
  IconAlertRhombusOutlineComponent,
  IconAlignHorizontalCenterComponent,
  IconAlignVerticalCenterComponent,
  IconAlphaComponent,
  IconApplicationCogComponent,
  IconApplicationCogOutlineComponent,
  IconArchiveMarkerComponent,
  IconArchiveMarkerOutlineComponent,
  IconArrowDownComponent,
  IconArrowLeftComponent,
  IconArrowRightComponent,
  IconArrowUpComponent,
  IconBackspaceOutlineComponent,
  IconBandageComponent,
  IconBarcodeComponent,
  IconBarcodeOffComponent,
  IconBarcodeScanComponent,
  IconBellOffOutlineComponent,
  IconBellOutlineComponent,
  IconBetaComponent,
  IconBiohazardComponent,
  IconBookSettingsComponent,
  IconBookSettingsOutlineComponent,
  IconBugComponent,
  IconBugOutlineComponent,
  IconCBoxOutlineComponent,
  IconCalculatorComponent,
  IconCalendarComponent,
  IconCalendarClearComponent,
  IconCalendarMultiselectComponent,
  IconCalendarMultiselectOutlineComponent,
  IconCameraComponent,
  IconCameraLockComponent,
  IconCameraLockOpenComponent,
  IconCameraLockOpenOutlineComponent,
  IconCameraLockOutlineComponent,
  IconCameraOffComponent,
  IconCameraOffOutlineComponent,
  IconCameraOutlineComponent,
  IconCancelComponent,
  IconCartComponent,
  IconCartFilledComponent,
  IconCartOutlineComponent,
  IconCartVariantComponent,
  IconCashComponent,
  IconCashCheckComponent,
  IconCashClockComponent,
  IconCashEditComponent,
  IconCashFastComponent,
  IconCashLockComponent,
  IconCashLockOpenComponent,
  IconCashMarkerComponent,
  IconCashMinusComponent,
  IconCashMultipleComponent,
  IconCashOffComponent,
  IconCashPlusComponent,
  IconCashRefundComponent,
  IconCashRegisterComponent,
  IconCashRemoveComponent,
  IconCashSyncComponent,
  IconChatComponent,
  IconChatOutlineComponent,
  IconCheckAllComponent,
  IconCheckBoldComponent,
  IconCheckCircleComponent,
  IconCheckCircleOutlineComponent,
  IconCheckOutlineComponent,
  IconCheckUnderlineComponent,
  IconCheckUnderlineCircleComponent,
  IconCheckUnderlineCircleOutlineComponent,
  IconChemicalWeaponComponent,
  IconChevronDownComponent,
  IconChevronLeftCircleOutlineComponent,
  IconChevronLeftComponent,
  IconChevronRightCircleOutlineComponent,
  IconChevronRightComponent,
  IconChevronUpComponent,
  IconClipboardComponent,
  IconClipboardCheckOutlineComponent,
  IconClockComponent,
  IconCloseBoxComponent,
  IconCloseBoxOutlineComponent,
  IconCloseCircleComponent,
  IconCloseCircleOutlineComponent,
  IconCloseComponent,
  IconCloseOctagonComponent,
  IconCloseOctagonOutlineComponent,
  IconCloseOutlineComponent,
  IconCloseThickComponent,
  IconCogBoxComponent,
  IconCogComponent,
  IconCogOutlineComponent,
  IconContentCopyComponent,
  IconContentSaveComponent,
  IconContentSaveOutlineComponent,
  IconCreateComponent,
  IconCustomSortUpDownComponent,
  IconDeleteComponent,
  IconDeleteClockComponent,
  IconDeleteClockOutlineComponent,
  IconDeleteEmptyComponent,
  IconDeleteEmptyOutlineComponent,
  IconDeleteForeverComponent,
  IconDeleteForeverOutlineComponent,
  IconDeleteOutlineComponent,
  IconDeleteSweepComponent,
  IconDeleteSweepOutlineComponent,
  IconDeltaComponent,
  IconDevToComponent,
  IconDotsVerticalComponent,
  IconDownloadComponent,
  IconDownloadOutlineComponent,
  IconEmailAlertOutlineComponent,
  IconEmailCheckOutlineComponent,
  IconEmailFastOutlineComponent,
  IconEmailPlusComponent,
  IconEmailPlusOutlineComponent,
  IconEmailRemoveComponent,
  IconEmailRemoveOutlineComponent,
  IconEmailSyncOutlineComponent,
  IconEmailVariantComponent,
  IconEpsilonComponent,
  IconEyeOffOutlineComponent,
  IconEyeOutlineComponent,
  IconFileCogComponent,
  IconFileCogOutlineComponent,
  IconFileTrayStackedComponent,
  IconFilterCogOutlineComponent,
  IconFilterVariantComponent,
  IconFilterVariantMinusComponent,
  IconFilterVariantPlusComponent,
  IconFilterVariantRemoveComponent,
  IconFlagOutlineComponent,
  IconFlashlightComponent,
  IconFlashlightOffComponent,
  IconFolderComponent,
  IconFolderAlertComponent,
  IconFormatAlignCenterComponent,
  IconFormatAlignLeftComponent,
  IconFormatAlignRightComponent,
  IconFormatBoldComponent,
  IconFormatItalicComponent,
  IconFullScreenComponent,
  IconFullScreenExitComponent,
  IconGammaComponent,
  IconGoogleDinosaurComponent,
  IconHelpCircleOutlineComponent,
  IconHomeComponent,
  IconInfoSlabCircleOutlineComponent,
  IconKeyComponent,
  IconLinkVariantComponent,
  IconLockClosedOutlineComponent,
  IconLockOpenOutlineComponent,
  IconLogInComponent,
  IconLogoIQComponent,
  IconMagnifyComponent,
  IconMagnifyMinusOutlineComponent,
  IconMagnifyPlusOutlineComponent,
  IconMagnifyRemoveOutlineComponent,
  IconMailComponent,
  IconMenuComponent,
  IconMessageAlertComponent,
  IconMessageAlertOutlineComponent,
  IconNewBoxComponent,
  IconNotEqualVariantComponent,
  IconOpenInNewComponent,
  IconPageFirstComponent,
  IconPageLastComponent,
  IconPauseBoxComponent,
  IconPauseBoxOutlineComponent,
  IconPauseComponent,
  IconPdfBoxComponent,
  IconPencilComponent,
  IconPencilOffComponent,
  IconPersonComponent,
  IconPersonMinusOutlineComponent,
  IconPersonMultipleMinusOutlineComponent,
  IconPersonMultiplePlusOutlineComponent,
  IconPersonOffOutlineComponent,
  IconPersonPlusOutlineComponent,
  IconPieChartComponent,
  IconPintComponent,
  IconPlanetComponent,
  IconPlayBoxComponent,
  IconPlayBoxOutlineComponent,
  IconPlayComponent,
  IconPlaylistPlusComponent,
  IconPlusComponent,
  IconPriceTagsComponent,
  IconPrinterOutlineComponent,
  IconProgressClockComponent,
  IconProgressPencilComponent,
  IconRadioboxBlankComponent,
  IconRadioboxMarkedComponent,
  IconReceiptOutlineComponent,
  IconReceiptTextCheckOutlineComponent,
  IconReceiptTextEditOutlineComponent,
  IconReceiptTextOutlineComponent,
  IconReceiptTextRemoveOutlineComponent,
  IconReceiptTextSendOutlineComponent,
  IconRotateOrbitComponent,
  IconSecurityComponent,
  IconSettingsComponent,
  IconShieldAirplaneComponent,
  IconShieldAirplaneOutlineComponent,
  IconShoppingComponent,
  IconShoppingOutlineComponent,
  IconSkullScanComponent,
  IconSkullScanOutlineComponent,
  IconSortComponent,
  IconStoreComponent,
  IconStoreEditComponent,
  IconStoreEditOutlineComponent,
  IconStoreMultipleComponent,
  IconStoreOutlineComponent,
  IconStoreRemoveComponent,
  IconSyncComponent,
  IconSwapVerticalComponent,
  IconTableCogComponent,
  IconTagMultipleComponent,
  IconTagMultipleOutlineComponent,
  IconTerminalComponent,
  IconTimerSandComponent,
  IconTodayComponent,
  IconTuneComponent,
  IconTuneVariantComponent,
  IconTuneVerticalComponent,
  IconTuneVerticalVariantComponent,
  LogoFullComponent,
  LogoGComponent,
  StylingSvgComponent,
  StylingSvgLoginComponent,
];
//#endregion

//#region ICON MAP (enum -> component) (alphabetical by key)
export const ICON_COMPONENTS: Record<IconKey, Type<unknown>> = {
  [IconKey.account]: IconAccountComponent,
  [IconKey.accountCog]: IconAccountCogComponent,
  [IconKey.accountCogOutline]: IconAccountCogOutlineComponent,
  [IconKey.accountEdit]: IconAccountEditComponent,
  [IconKey.accountEditOutline]: IconAccountEditOutlineComponent,
  [IconKey.accountMinus]: IconAccountMinusComponent,
  [IconKey.accountMinusOutline]: IconAccountMinusOutlineComponent,
  [IconKey.accountOutline]: IconAccountOutlineComponent,
  [IconKey.accountPlus]: IconAccountPlusComponent,
  [IconKey.accountPlusOutline]: IconAccountPlusOutlineComponent,
  [IconKey.accountRemove]: IconAccountRemoveComponent,
  [IconKey.accountRemoveOutline]: IconAccountRemoveOutlineComponent,
  [IconKey.alertBox]: IconAlertBoxComponent,
  [IconKey.alertBoxOutline]: IconAlertBoxOutlineComponent,
  [IconKey.alertRhombus]: IconAlertRhombusComponent,
  [IconKey.alertRhombusOutline]: IconAlertRhombusOutlineComponent,
  [IconKey.alignHorizontalCenter]: IconAlignHorizontalCenterComponent,
  [IconKey.alignVerticalCenter]: IconAlignVerticalCenterComponent,
  [IconKey.alpha]: IconAlphaComponent,
  [IconKey.applicationCog]: IconApplicationCogComponent,
  [IconKey.applicationCogOutline]: IconApplicationCogOutlineComponent,
  [IconKey.archiveMarker]: IconArchiveMarkerComponent,
  [IconKey.archiveMarkerOutline]: IconArchiveMarkerOutlineComponent,
  [IconKey.arrowDown]: IconArrowDownComponent,
  [IconKey.arrowLeft]: IconArrowLeftComponent,
  [IconKey.arrowRight]: IconArrowRightComponent,
  [IconKey.arrowUp]: IconArrowUpComponent,
  [IconKey.backSpaceOutline]: IconBackspaceOutlineComponent,
  [IconKey.bandage]: IconBandageComponent,
  [IconKey.barcode]: IconBarcodeComponent,
  [IconKey.barcodeOff]: IconBarcodeOffComponent,
  [IconKey.barcodeScan]: IconBarcodeScanComponent,
  [IconKey.bellOffOutline]: IconBellOffOutlineComponent,
  [IconKey.bellOutline]: IconBellOutlineComponent,
  [IconKey.beta]: IconBetaComponent,
  [IconKey.biohazard]: IconBiohazardComponent,
  [IconKey.bookSettings]: IconBookSettingsComponent,
  [IconKey.bookSettingsOutline]: IconBookSettingsComponent,
  [IconKey.bug]: IconBugComponent,
  [IconKey.bugOutline]: IconBugOutlineComponent,
  [IconKey.cBoxOutline]: IconCBoxOutlineComponent,
  [IconKey.calculator]: IconCalculatorComponent,
  [IconKey.calendar]: IconCalendarComponent,
  [IconKey.calendarClear]: IconCalendarClearComponent,
  [IconKey.calendarMultiSelect]: IconCalendarMultiselectComponent,
  [IconKey.calendarMultiSelectOutline]: IconCalendarMultiselectOutlineComponent,
  [IconKey.camera]: IconCameraComponent,
  [IconKey.cameraLock]: IconCameraLockComponent,
  [IconKey.cameraLockOpen]: IconCameraLockOpenComponent,
  [IconKey.cameraLockOpenOutline]: IconCameraLockOpenOutlineComponent,
  [IconKey.cameraLockOutline]: IconCameraLockOutlineComponent,
  [IconKey.cameraOff]: IconCameraOffComponent,
  [IconKey.cameraOffOutline]: IconCameraOffOutlineComponent,
  [IconKey.cameraOutline]: IconCameraOutlineComponent,
  [IconKey.cancel]: IconCancelComponent,
  [IconKey.cart]: IconCartComponent,
  [IconKey.cartFilled]: IconCartFilledComponent,
  [IconKey.cartOutline]: IconCartOutlineComponent,
  [IconKey.cartVariant]: IconCartVariantComponent,
  [IconKey.cash]: IconCashComponent,
  [IconKey.cashCheck]: IconCashCheckComponent,
  [IconKey.cashClock]: IconCashClockComponent,
  [IconKey.cashEdit]: IconCashEditComponent,
  [IconKey.cashFast]: IconCashFastComponent,
  [IconKey.cashLock]: IconCashLockComponent,
  [IconKey.cashLockOpen]: IconCashLockOpenComponent,
  [IconKey.cashMarker]: IconCashMarkerComponent,
  [IconKey.cashMinus]: IconCashMinusComponent,
  [IconKey.cashMultiple]: IconCashMultipleComponent,
  [IconKey.cashOff]: IconCashOffComponent,
  [IconKey.cashPlus]: IconCashPlusComponent,
  [IconKey.cashRefund]: IconCashRefundComponent,
  [IconKey.cashRegister]: IconCashRegisterComponent,
  [IconKey.cashRemove]: IconCashRemoveComponent,
  [IconKey.cashSync]: IconCashSyncComponent,
  [IconKey.chat]: IconChatComponent,
  [IconKey.chatOutline]: IconChatOutlineComponent,
  [IconKey.checkAll]: IconCheckAllComponent,
  [IconKey.checkBold]: IconCheckBoldComponent,
  [IconKey.checkCircle]: IconCheckCircleComponent,
  [IconKey.checkCircleOutline]: IconCheckCircleOutlineComponent,
  [IconKey.checkOutline]: IconCheckOutlineComponent,
  [IconKey.checkUnderline]: IconCheckUnderlineComponent,
  [IconKey.checkUnderlineCircle]: IconCheckUnderlineCircleComponent,
  [IconKey.checkUnderlineCircleOutline]: IconCheckUnderlineCircleOutlineComponent,
  [IconKey.chemicalWeapon]: IconChemicalWeaponComponent,
  [IconKey.chevronDown]: IconChevronDownComponent,
  [IconKey.chevronLeft]: IconChevronLeftComponent,
  [IconKey.chevronLeftCircleOutline]: IconChevronLeftCircleOutlineComponent,
  [IconKey.chevronRight]: IconChevronRightComponent,
  [IconKey.chevronRightCircleOutline]: IconChevronRightCircleOutlineComponent,
  [IconKey.chevronUp]: IconChevronUpComponent,
  [IconKey.clipboard]: IconClipboardComponent,
  [IconKey.clipboardCheckOutline]: IconClipboardCheckOutlineComponent,
  [IconKey.clock]: IconClockComponent,
  [IconKey.close]: IconCloseComponent,
  [IconKey.closeBox]: IconCloseBoxComponent,
  [IconKey.closeBoxOutline]: IconCloseBoxOutlineComponent,
  [IconKey.closeCircle]: IconCloseCircleComponent,
  [IconKey.closeCircleOutline]: IconCloseCircleOutlineComponent,
  [IconKey.closeOctagon]: IconCloseOctagonComponent,
  [IconKey.closeOctagonOutline]: IconCloseOctagonOutlineComponent,
  [IconKey.closeOutline]: IconCloseOutlineComponent,
  [IconKey.closeThick]: IconCloseThickComponent,
  [IconKey.cog]: IconCogComponent,
  [IconKey.cogBox]: IconCogBoxComponent,
  [IconKey.cogOutline]: IconCogOutlineComponent,
  [IconKey.contentCopy]: IconContentCopyComponent,
  [IconKey.contentSave]: IconContentSaveComponent,
  [IconKey.contentSaveOutline]: IconContentSaveOutlineComponent,
  [IconKey.create]: IconCreateComponent,
  [IconKey.customSortUpDown]: IconCustomSortUpDownComponent,
  [IconKey.delta]: IconDeltaComponent,
  [IconKey.delete]: IconDeleteComponent,
  [IconKey.deleteClock]: IconDeleteClockComponent,
  [IconKey.deleteClockOutline]: IconDeleteClockOutlineComponent,
  [IconKey.deleteEmpty]: IconDeleteEmptyComponent,
  [IconKey.deleteEmptyOutline]: IconDeleteEmptyOutlineComponent,
  [IconKey.deleteForever]: IconDeleteForeverComponent,
  [IconKey.deleteForeverOutline]: IconDeleteForeverOutlineComponent,
  [IconKey.deleteOutline]: IconDeleteOutlineComponent,
  [IconKey.deleteSweep]: IconDeleteSweepComponent,
  [IconKey.deleteSweepOutline]: IconDeleteSweepOutlineComponent,
  [IconKey.devTo]: IconDevToComponent,
  [IconKey.dotsVertical]: IconDotsVerticalComponent,
  [IconKey.download]: IconDownloadComponent,
  [IconKey.downloadOutline]: IconDownloadOutlineComponent,
  [IconKey.emailAlertOutline]: IconEmailAlertOutlineComponent,
  [IconKey.emailCheckOutline]: IconEmailCheckOutlineComponent,
  [IconKey.emailFastOutline]: IconEmailFastOutlineComponent,
  [IconKey.emailPlus]: IconEmailPlusComponent,
  [IconKey.emailPlusOutline]: IconEmailPlusOutlineComponent,
  [IconKey.emailRemove]: IconEmailRemoveComponent,
  [IconKey.emailRemoveOutline]: IconEmailRemoveOutlineComponent,
  [IconKey.emailSyncOutline]: IconEmailSyncOutlineComponent,
  [IconKey.emailVariant]: IconEmailVariantComponent,
  [IconKey.epsilon]: IconEpsilonComponent,
  [IconKey.eyeOffOutline]: IconEyeOffOutlineComponent,
  [IconKey.eyeOutline]: IconEyeOutlineComponent,
  [IconKey.fileCog]: IconFileCogComponent,
  [IconKey.fileCogOutline]: IconFileCogOutlineComponent,
  [IconKey.fileTrayStacked]: IconFileTrayStackedComponent,
  [IconKey.filterCogOutline]: IconFilterCogOutlineComponent,
  [IconKey.filterVariant]: IconFilterVariantComponent,
  [IconKey.filterVariantMinus]: IconFilterVariantMinusComponent,
  [IconKey.filterVariantPlus]: IconFilterVariantPlusComponent,
  [IconKey.filterVariantRemove]: IconFilterVariantRemoveComponent,
  [IconKey.flagOutline]: IconFlagOutlineComponent,
  [IconKey.flashlight]: IconFlashlightComponent,
  [IconKey.flashlightOff]: IconFlashlightOffComponent,
  [IconKey.folder]: IconFolderComponent,
  [IconKey.folderAlert]: IconFolderAlertComponent,
  [IconKey.formatAlignCenter]: IconFormatAlignCenterComponent,
  [IconKey.formatAlignLeft]: IconFormatAlignLeftComponent,
  [IconKey.formatAlignRight]: IconFormatAlignRightComponent,
  [IconKey.formatBold]: IconFormatBoldComponent,
  [IconKey.formatItalic]: IconFormatItalicComponent,
  [IconKey.fullScreen]: IconFullScreenComponent,
  [IconKey.fullScreenExit]: IconFullScreenExitComponent,
  [IconKey.gamma]: IconGammaComponent,
  [IconKey.googleDinosaur]: IconGoogleDinosaurComponent,
  [IconKey.helpCircleOutline]: IconHelpCircleOutlineComponent,
  [IconKey.home]: IconHomeComponent,
  [IconKey.infoSlabCircleOutline]: IconInfoSlabCircleOutlineComponent,
  [IconKey.key]: IconKeyComponent,
  [IconKey.linkVariant]: IconLinkVariantComponent,
  [IconKey.lockClosedOutline]: IconLockClosedOutlineComponent,
  [IconKey.lockOpenOutline]: IconLockOpenOutlineComponent,
  [IconKey.logIn]: IconLogInComponent,
  [IconKey.logoFull]: LogoFullComponent,
  [IconKey.logoG]: LogoGComponent,
  [IconKey.logoIQ]: IconLogoIQComponent,
  [IconKey.magnify]: IconMagnifyComponent,
  [IconKey.magnifyMinus]: IconMagnifyMinusOutlineComponent,
  [IconKey.magnifyPlus]: IconMagnifyPlusOutlineComponent,
  [IconKey.magnifyRemove]: IconMagnifyRemoveOutlineComponent,
  [IconKey.mail]: IconMailComponent,
  [IconKey.menu]: IconMenuComponent,
  [IconKey.messageAlert]: IconMessageAlertComponent,
  [IconKey.messageAlertOutline]: IconMessageAlertOutlineComponent,
  [IconKey.newBox]: IconNewBoxComponent,
  [IconKey.notEqualVariant]: IconNotEqualVariantComponent,
  [IconKey.openInNew]: IconOpenInNewComponent,
  [IconKey.pageFirst]: IconPageFirstComponent,
  [IconKey.pageLast]: IconPageLastComponent,
  [IconKey.pause]: IconPauseComponent,
  [IconKey.pauseBox]: IconPauseBoxComponent,
  [IconKey.pauseBoxOutline]: IconPauseBoxOutlineComponent,
  [IconKey.pdfBox]: IconPdfBoxComponent,
  [IconKey.pencil]: IconPencilComponent,
  [IconKey.pencilOff]: IconPencilOffComponent,
  [IconKey.person]: IconPersonComponent,
  [IconKey.personMinusOutline]: IconPersonMinusOutlineComponent,
  [IconKey.personMultipleMinusOutline]: IconPersonMultipleMinusOutlineComponent,
  [IconKey.personMultiplePlusOutline]: IconPersonMultiplePlusOutlineComponent,
  [IconKey.personOffOutline]: IconPersonOffOutlineComponent,
  [IconKey.personPlusOutline]: IconPersonPlusOutlineComponent,
  [IconKey.pieChart]: IconPieChartComponent,
  [IconKey.pint]: IconPintComponent,
  [IconKey.planet]: IconPlanetComponent,
  [IconKey.play]: IconPlayComponent,
  [IconKey.playBox]: IconPlayBoxComponent,
  [IconKey.playBoxOutline]: IconPlayBoxOutlineComponent,
  [IconKey.playlistPlus]: IconPlaylistPlusComponent,
  [IconKey.plus]: IconPlusComponent,
  [IconKey.priceTags]: IconPriceTagsComponent,
  [IconKey.printerOutline]: IconPrinterOutlineComponent,
  [IconKey.progressClock]: IconProgressClockComponent,
  [IconKey.progressPencil]: IconProgressPencilComponent,
  [IconKey.radioBoxBlank]: IconRadioboxBlankComponent,
  [IconKey.radioBoxMarked]: IconRadioboxMarkedComponent,
  [IconKey.receiptOutline]: IconReceiptOutlineComponent,
  [IconKey.receiptTextCheckOutline]: IconReceiptTextCheckOutlineComponent,
  [IconKey.receiptTextEditOutline]: IconReceiptTextEditOutlineComponent,
  [IconKey.receiptTextOutline]: IconReceiptTextOutlineComponent,
  [IconKey.receiptTextRemoveOutline]: IconReceiptTextRemoveOutlineComponent,
  [IconKey.receiptTextSendOutline]: IconReceiptTextSendOutlineComponent,
  [IconKey.rotateOrbit]: IconRotateOrbitComponent,
  [IconKey.security]: IconSecurityComponent,
  [IconKey.settings]: IconSettingsComponent,
  [IconKey.shieldAirplane]: IconShieldAirplaneComponent,
  [IconKey.shieldAirplaneOutline]: IconShieldAirplaneOutlineComponent,
  [IconKey.shopping]: IconShoppingComponent,
  [IconKey.shoppingOutline]: IconShoppingOutlineComponent,
  [IconKey.skullScan]: IconSkullScanComponent,
  [IconKey.skullScanOutline]: IconSkullScanOutlineComponent,
  [IconKey.sort]: IconSortComponent,
  [IconKey.store]: IconStoreComponent,
  [IconKey.storeMultiple]: IconStoreMultipleComponent,
  [IconKey.storeEdit]: IconStoreEditComponent,
  [IconKey.storeEditOutline]: IconStoreEditOutlineComponent,
  [IconKey.storeOutline]: IconStoreOutlineComponent,
  [IconKey.storeRemove]: IconStoreRemoveComponent,
  [IconKey.stylingSvg]: StylingSvgComponent,
  [IconKey.stylingSvgLogin]: StylingSvgLoginComponent,
  [IconKey.sync]: IconSyncComponent,
  [IconKey.swapVertical]: IconSwapVerticalComponent,
  [IconKey.tableCog]: IconTableCogComponent,
  [IconKey.tagMultiple]: IconTagMultipleComponent,
  [IconKey.tagMultipleOutline]: IconTagMultipleOutlineComponent,
  [IconKey.terminal]: IconTerminalComponent,
  [IconKey.timerSand]: IconTimerSandComponent,
  [IconKey.today]: IconTodayComponent,
  [IconKey.tune]: IconTuneComponent,
  [IconKey.tuneVariant]: IconTuneVariantComponent,
  [IconKey.tuneVertical]: IconTuneVerticalComponent,
  [IconKey.tuneVerticalVariant]: IconTuneVerticalVariantComponent,
  [IconKey.undo]: IconUndoComponent,
  [IconKey.undoVariant]: IconUndoVariantComponent,
};
//#endregion
